import React from 'react'

export const NothingToShow = ({dato}) => {
    return (
        <div className = "Bio" >
            <h1>Aun no hay {dato} que mostrar</h1>
        </div>
    )
}
